export { UIGamePlayerInformation } from './UIGamePlayerInformation.tsx';
export { getGlobalPositionOfPlayerCard } from './UIGamePlayerInformationContainer.tsx';
